import React from 'react';
import { ArrowRightLeft } from 'lucide-react';
import { noteText } from '../utils/notePresentation';

export default function CardFaceToggle({ showAnswers, onToggle, disabled = false }) {
  const label = noteText(showAnswers ? 'showAllQuestions' : 'showAllAnswers');
  return <button type="button" className="note-detail-button note-card-face-toggle" disabled={disabled}
    aria-pressed={showAnswers} aria-label={label} title={label} onClick={onToggle}>
    <span aria-hidden="true" className="note-card-face-label">Q<ArrowRightLeft size={15} />A</span>
  </button>;
}
